'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configDefaults = undefined;

var _nuiConfig = require('@concur/nui-config');

var _nuiConfig2 = _interopRequireDefault(_nuiConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configDefaults = exports.configDefaults = {
  nui: {
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://msprqa3.concurtech.net',
    clientExposed: true
  },
  enrollModalBase: {
    value: 'http://localhost',
    clientExposed: true
  },
  port: 3000,
  logger: {
    application: 'AppCenter',
    category: 'Web-API',
    roletype: 'appc'
  }
}; // https://concur.gitbooks.io/nui/content/nui-config/introduction.html
exports.default = (0, _nuiConfig2.default)(configDefaults);


//////////////////
// WEBPACK FOOTER
// ./lib/config.js
// module id = 55
// module chunks = 0